import React from 'react'
import img from "../assets/Profile.png"
import {MdDownload} from "react-icons/md"
import Typewriter from "typewriter-effect"
import resume from "../assets/Supriyo_Samanta_resume.pdf"
const Home = () => {
  return (
    <div name="Home" className="w-full bg-slate-800 h-screen pb-5">
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center
       h-full px-4 md:flex-row">
        <div  className=" flex flex-col justify-center h-full w-full "  data-aos="fade-right" data-aos-duration="1000">
          <h2 className=" text-3xl sm:text-4xl font-bold text-transparent bg-clip-text bg-slate-200 mb-1 pt-36"> 
                 Supriyo Samanta
            </h2>
            <div className='flex'>
            <h2 className=" text-xl sm:text-2xl font-bold text-transparent bg-clip-text bg-slate-200 mr-1"> 
                 I'm
            </h2>
            <h2 className=" text-xl sm:text-2xl font-bold text-transparent bg-clip-text bg-amber-500 "> 
            <Typewriter
            className="underline"
            options={{
            strings: [
            "Full Stack Developer",
            "Coder"
           ],
            autoStart: true,
            loop: true,
            deleteSpeed: 100,
              }}
              />
            </h2>
            </div>
          
          <p className=' text-slate-200 py-4 text-xl'>
           
          I fell in love with programming and I have at least learnt something, I think
          <br/>
          I am fluent in <strong className='text-amber-500'>Javascript,reactjs,HTML,CSS.</strong>
          <br/>
          My field of Interest's is building new Web Sites with Modern Technologies Like <strong className='text-amber-500'>ReactJs,NodeJs,ExpressJs,MongoDB</strong>
          </p>
          <div className='flex'>
            <button className=' group text-white w-fit px-6 py-3 my-2
                flex items-center rounded-md bg-gradient-to-r from-cyan-500
                 to-blue-500 cursor-pointer mr-4'>
                <a download={true} href={resume} target="_blank" rel="noreferrer" className=' group-hover:scale-125 duration-300'>Resume</a>
              <span >
                <MdDownload size={25} className="ml-1 group-hover:scale-75 group-hover:ml-3 duration-300" />
              </span>
            </button>
          </div>
        </div>
        <div>
          <img src={img} alt="hero" className=" rounded-md mx-auto w-2/3 md:w-3/4"/>
        </div>
      </div>
    </div>
  )
}

export default Home